import React, { useContext, useMemo } from 'react'
import {SeekerContext} from "../context/SeekerContext"
import { SharedContext } from '../context/SharedContext'
import ImageWithBasePath from '../components/ImageWithBasePath'
import classNames from 'classnames'
import { NextLink } from './NextLink'
import { getAsPath } from '../utils/functions'

const generateBreadcrumbs = (page, location, body, jobDetails, filterTitleIds) => {
  switch (page) {
    case 'jobsFiltering':
      const basicCrumbs = [
        { name: 'Jobs', pathName: '/seekerHomePage', as: location ? `jobs/${location?.name || location?.title}` : '/jobs' },
        {
          name: `${location?.name || location?.title}`,
          pathName: '/locationSelectionPage',
          as: `/jobs/jobs-near-me`
        }
      ]
      if (body?.selectedOptions?.[37]?.[0]) {
        basicCrumbs.push({
          name: `${body?.selectedOptions?.[37]?.[0]?.title}`,
          pathName: '/jobsFiltering',
          as: `jobs/${getAsPath({ selectedOptions: body?.selectedOptions, filterTitleIds })}`
        })
      }
      return basicCrumbs
    case 'jobsDetails':
      return [
        { name: 'Jobs', pathName: '/seekerHomePage', as: location ? `jobs/${location?.name || location?.title}` : '/jobs' },
        {
          name: `${location?.name || location?.title}`,
          pathName: '/locationSelectionPage',
          as: `/jobs/jobs-near-me`
        },
        {
          name: `${jobDetails?.job_category}`,
          pathName: '/jobsFiltering',
          as: `jobs/${getAsPath({ selectedOptions: body?.selectedOptions, filterTitleIds })}`
        },
        { name: `${jobDetails?.id}`, pathName: '', as: '' }
      ]
    default:
      return []
  }
}

export const BreadCrumbs = ({ page, jobDetails = {} }) => {
  const { location } = useContext(SharedContext);
  const { body, filterTitleIds } = useContext(SeekerContext);
  const breadCrumbs = useMemo(
    () => generateBreadcrumbs(page, location, body, jobDetails, filterTitleIds),
    [page, location, body, jobDetails, filterTitleIds]
  )

  return (
    <>
      <div className="flex flex-wrap font-noto-sans text-[11.5px] font-bold leading-[14.98px] tracking-[1px]">
        {(breadCrumbs || [])?.map((item, index) => {
          const isLastIndex = breadCrumbs?.length - 1 == index
          return (
            <div className="flex items-center" key={index}>
              <NextLink
                className={classNames(
                  'select-none',
                  !isLastIndex ? 'text-[#97989B]' : 'text-[#4B4B4E]'
                )}
                href={item?.pathName}
                as={item?.as}
                isLoader={false}
                id={item?.name + index}
                disabled={!item?.pathName}
              >
                {item?.name || ''}
              </NextLink>
              {!isLastIndex && (
                <div className="relative mx-[4px] h-[8px] w-[8px]">
                  <ImageWithBasePath src="bread_arrow_forward" fill alt="forward arrow" />
                </div>
              )}
            </div>
          )
        })}
      </div>
    </>
  )
}
